import React, { useContext, useEffect, useRef, useState } from "react";
import "../../css_files/Quotation/Quotations.css";
import axios from "axios";
import { getCookie } from "../../api";
import QuotationCard from "./QuotationCard";
import QuotationTable from "./QuotationTable";
import { ToastContainer } from "react-toastify";
import QuotationPopup from "./QuotationPopup";
import { triggerscroll } from "../Homepage/Homepage";
import { jwtDecode } from "jwt-decode";
import axiosInstance from "../../api";
import Pagination from "../Homepage/Pagination";
import { toast } from "react-toastify";

function Quotations({
  setEnquiryId,
  setTicketId,
  setQuotationId,
  quotationId,
}) {
  const [quotationData, setQuotationData] = useState([]);
  const [view, setView] = useState("Grid");
  const [refresh, setrefresh] = useState(false);
  const { setExpiredSession, userData, permissionsdata } =
    useContext(triggerscroll);
  const [search, setSearch] = useState(false);
  const [quotationType, setQuotationType] = useState("Service");
  const [loading, setloading] = useState(false);
  const [page, setpage] = useState(1);
  const [pages, setpages] = useState(0);
  const [excelLoading, setExcelLoading] = useState(false);
  const [count, setcount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloading(true);
        const url = search
          ? `${process.env.REACT_APP_API_URL}/api/v1/Quotation/SearchQuotation?search=${searchTerm}&page=${page}&EnquiryType=${quotationType}`
          : `${process.env.REACT_APP_API_URL}/api/v1/Quotation?page=${page}&type=${quotationType}`;

        const quotationRes = await axiosInstance.get(url);
        setpages(quotationRes.data.pages);
        setcount(quotationRes.data.count);
        setQuotationData(quotationRes.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setloading(false);
      }
    };

    fetchData();
  }, [refresh, page, quotationType, search]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" &&
        x.subHead === "Quotation" &&
        x.isRead === true
    );
    return issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" &&
        x.subHead === "Quotation" &&
        x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" &&
        x.subHead === "Quotation" &&
        x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="quotations">
      <div className="quotations-nav">
        <h1>Quotations</h1>

        <blockquote>
          <input
            type="search"
            placeholder="Enter Serach Keyword"
            onChange={(e) => {
              setSearch(e.target.value?.trim() !== "");
              setSearchTerm(e.target.value);
              setpage(1);
            }}
          />
          <i
            className="fa-solid fa-search"
            onClick={() => {
              setrefresh(!refresh);
            }}
          ></i>
          <button
            onClick={() => setView("Grid")}
            style={{
              backgroundColor: view === "Grid" && "blue",
              color: view === "Grid" && "white",
            }}
          >
            <i class="fa-solid fa-table-cells-large"></i>
          </button>
          <button
            onClick={() => setView("List")}
            style={{
              backgroundColor: view === "List" && "blue",
              color: view === "List" && "white",
            }}
          >
            <i class="fa-solid fa-bars"></i>
          </button>
          {/*excelLoading ? (
              <button>
                <i className="fa-solid fa-rotate-right fa-spin"></i>
              </button>
            ) : (
              <button
                onClick={() => {
                  setExcelLoading(true);
                  axiosInstance
                    .get(
                      `${process.env.REACT_APP_API_URL}/api/Excel/DataBackup?name=Quotation`,
                      { responseType: "blob" }
                    )
                    .then((res) => {
                      const blob = new Blob([res.data]);
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.download = `Quotation_${new Date().getMilliseconds()}.xlsx`;
                      a.href = url;
                      a.click();
                      window.URL.revokeObjectURL(url);
                      toast.success("Data Exported to Excel Successfully", {
                        position: "bottom-center",
                        theme: "dark",
                      });
                      setExcelLoading(false);
                    })
                    .catch((err) => {
                      console.log(err);
                      setExcelLoading(false);
                    });
                }}
              >
                <i class="fa-solid fa-file-export"></i>
              </button>
            )*/}
        </blockquote>
      </div>
      <blockquote id="ticketToggleinTickets">
        <mark>{quotationType} Quotations</mark>
        <i
          className="fa-solid fa-repeat"
          onClick={() => {
            setQuotationType(quotationType === "Service" ? "Parts" : "Service");
            setpage(1);
          }}
        ></i>
        <h3>{count} records</h3>
      </blockquote>
      {view === "List" ? (
        <div className="quotation-cards">
          {readPermission() ? (
            quotationData.length > 0 ? (
              quotationData.map((quotation) => (
                <QuotationCard
                  quotation={quotation}
                  setEnquiryId={setEnquiryId}
                  setTicketId={setTicketId}
                  setQuotationId={setQuotationId}
                  refresh={refresh}
                  setrefresh={setrefresh}
                  updatePermission={updatePermission}
                  deletePermission={deletePermission}
                />
              ))
            ) : (
              <center>No Records Found</center>
            )
          ) : (
            <center>You Do Not Have Permission To Read Data</center>
          )}
        </div>
      ) : (
        <QuotationTable
          quotationData={quotationData}
          setEnquiryId={setEnquiryId}
          setTicketId={setTicketId}
          setQuotationId={setQuotationId}
          refresh={refresh}
          setrefresh={setrefresh}
          loading={loading}
          readPermission={readPermission}
          updatePermission={updatePermission}
          deletePermission={deletePermission}
        />
      )}
      <br />
      <Pagination count={pages} pagenumber={page} setpagenumber={setpage} />
    </section>
  );
}

export default Quotations;
